import { ENV } from '@user-portal/helpers';

import { A_B_TEST_NAME, SYSTEMS_NAMES } from '../enums';
import { pushToGTM, installGtm } from '../helpers/GoogleTagManager';
import { generateStringifyQueryParams } from '../helpers/GoogleAnalytic4';
import Core from './SystemsCore';
import Utils from '../helpers/Utils';
import DataProvider from '../DataProvider';
import { GTMEvent } from '../Interfaces/Events';
import SystemsRegistry from '../SystemsRegistry';

export default class GoogleTagManager extends Core {
  private state: {
    isInit: boolean;
    anonymize: boolean;
  };
  private envMode: string;
  public name: string;

  constructor() {
    super();
    this.name = SYSTEMS_NAMES.gtm;
    this.envMode = ENV.develop;
    this.state = {
      isInit: false,
      anonymize: false,
    };
  }

  init({ id }: { id: string }) {
    try {
      installGtm(id);

      this.state.isInit = true;
    } catch (error) {
      console.warn('GTM init error ', error);
    }
  }

  getInit() {
    return this.state.isInit;
  }

  getABTestName() {
    return A_B_TEST_NAME;
  }

  // empty methods to preserve the interface
  async track() {}
  async trackNew() {}
  async purchase() {}
  async purchaseNew() {}

  getAnalyticsData = async () => {
    return await SystemsRegistry.getInstance().getAmazonAnalyticsData();
  };

  async trackGTM({ name, type = 'custom_event', data = {} }: GTMEvent) {
    const eventLabel = data?.event_label;
    const urlParams = await generateStringifyQueryParams();

    const {
      pageType,
      value,
      price,
      currency,
      order_id,
      content_id,
      tariff,
      payment,
      subscription_price,
      subscription_id,
      order_type,
      screen_id,
      newCustomer,
      ...rest
    } = data;

    pushToGTM({
      event: type,
      eventName: name,
      abTestName: await DataProvider.getAbTestName(),
      eventLabel,
      mode: this.envMode,
      pageType,
      lang: Utils.getNavigatorLanguage(),
      userId: DataProvider.getUserId(),
      awsId: (await this.getAnalyticsData()).aws_id,
      gender: DataProvider.getGender(),
      uuid: Utils.getUuid(),
      transaction_id: order_id,
      value,
      price,
      currency,
      item_name: content_id,
      item_id: tariff,
      paymentType: payment,
      subscriptionPrice: subscription_price,
      subscriptionId: subscription_id,
      orderType: order_type,
      screenId: screen_id,
      newCustomer,
      ...(urlParams && {
        pageLocation: `${window.location.href}/?${urlParams}`,
      }),
      ...rest,
    });
  }
}
